import { toast } from 'react-toastify'

export const showError = (text: string = 'Please try again or contact support.') => {
    toast.error(text);
}